import React, { useState } from 'react'

const defaultContexto = {
  bloquearChecks: false,
  setbloquearChecks:(estado:boolean) =>{},
  mostrarModalReplanificacion : false,
  setmostrarModalReplanificacion:(estado:boolean) =>{},

}

const SolicitudesVacacionesContext = React.createContext(
  {
    ...defaultContexto
  }
)


export function useSolicitudVacacionesContext() {
    const contexto = React.useContext(SolicitudesVacacionesContext);
    if (!contexto) {
        throw new Error('Para usar el hook asegurese de ser hijo del Proveedor SolicitudVacacionesContextProvider');
    }
    return contexto;
}



const SolicitudVacacionesContextProvider:React.FC = ({children}) => {
  const [bloquearChecks, setbloquearChecks] = useState<boolean>(false);
  const [mostrarModalReplanificacion, setmostrarModalReplanificacion] = useState(false)
  const value = {
    bloquearChecks,
    setbloquearChecks,
    mostrarModalReplanificacion,
    setmostrarModalReplanificacion
  }

  return (

      <SolicitudesVacacionesContext.Provider value={value}>
          {children}
      </SolicitudesVacacionesContext.Provider>
  
  )
}

export default SolicitudVacacionesContextProvider;
